import { getDateOnlyKey } from './dateDisplay';

// Build per-student metrics from raw rows
export function computeAttendanceInsights(rows) {
  const byStudent = {};
  const dateSet = new Set();

  for (const r of rows) {
    const name = `${r.first_name ?? ''} ${r.last_name ?? ''}`.trim() || 'Unknown';
    const key = r.student_id ?? name;
    const status = String(r.status || '').toLowerCase().trim();

    if (r.date) dateSet.add(getDateOnlyKey(r.date));
    if (!byStudent[key]) {
      byStudent[key] = { key, name, present: 0, late: 0, absent: 0, excused: 0, total: 0, pct: 0 };
    }

    if (status === 'present' || status === 'absent' || status === 'excused') {
      if (status === 'present') {
        byStudent[key].present += 1;
        if (Number(r.is_late) === 1 || r.is_late === true) byStudent[key].late += 1;
      }
      if (status === 'absent')  byStudent[key].absent  += 1;
      if (status === 'excused') byStudent[key].excused += 1;
      byStudent[key].total += 1;
    }
  }

  for (const s of Object.values(byStudent)) {
    const countedTotal = s.present + s.absent;
    s.pct = countedTotal > 0 ? Math.round((s.present / countedTotal) * 100) : 0;
  }

  const all = Object.values(byStudent);
  const ranked = [...all].sort((a, b) => (b.pct - a.pct) || (a.absent - b.absent) || (b.total - a.total));
  const needsAttentionRanked = [...all].sort((a, b) => (b.absent - a.absent) || (a.pct - b.pct) || (b.total - a.total));
  const bestStudent = ranked[0] || null;
  const worstStudent = needsAttentionRanked[0]?.absent > 0 ? needsAttentionRanked[0] : null;
  const bestStudents = bestStudent ? ranked.filter((s) => s.pct === bestStudent.pct) : [];
  const worstStudents = worstStudent ? needsAttentionRanked.filter((s) => s.absent === worstStudent.absent) : [];

  return {
    totalMeetings: dateSet.size,
    byStudent,
    ranked,
    bestStudent,
    worstStudent,
    bestStudents,
    worstStudents,
    best: ranked.slice(0, 5),
    worst: needsAttentionRanked.slice(0, 5),
  };
}

export const hasChartableData = (list) =>
  Array.isArray(list) && list.some(s => Number(s.pct) > 0);

const BAR_COLOR = 'rgba(30, 93, 170, 0.85)';
const BAR_BORDER = 'rgba(30, 93, 170, 1)';

export function buildBarData(list, label) {
  return {
    labels: list.map(s => s.name),
    datasets: [
      {
        label,
        data: list.map(s => Number(s.pct) || 0),
        backgroundColor: BAR_COLOR,
        borderColor: BAR_BORDER,
        borderWidth: 1,
      }
    ]
  };
}

export const chartOptsPct = {
  responsive: true,
  maintainAspectRatio: false,
  animation: false,
  plugins: {
    legend: { display: false },
    tooltip: { callbacks: { label: ctx => `${ctx.parsed.y}%` } },
  },
  scales: {
    y: { beginAtZero: true, max: 100, ticks: { callback: v => `${v}%` } },
    x: { ticks: { autoSkip: false, maxRotation: 45, minRotation: 0 } },
  },
};
